/**
 * Custom Alert Modal Component
 * A beautiful replacement for browser's alert() function
 */

import React from 'react';
import { FaExclamationTriangle, FaTimes, FaCheckCircle, FaInfoCircle } from 'react-icons/fa';
import './CustomAlert.css';

const CustomAlert = ({ message, onClose, type = 'warning' }) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="alert-modal-icon success" />;
      case 'error':
        return <FaExclamationTriangle className="alert-modal-icon error" />;
      case 'info':
        return <FaInfoCircle className="alert-modal-icon info" />;
      case 'warning':
      default:
        return <FaExclamationTriangle className="alert-modal-icon warning" />;
    }
  };

  const getTitle = () => {
    switch (type) {
      case 'success':
        return 'Success';
      case 'error':
        return 'Error';
      case 'info':
        return 'Information';
      case 'warning':
      default:
        return 'Warning';
    }
  };

  return (
    <div className="alert-modal-backdrop" onClick={onClose}>
      <div className="alert-modal-container" onClick={(e) => e.stopPropagation()}>
        <button 
          className="alert-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <FaTimes />
        </button>
        
        <div className="alert-modal-icon-wrapper">
          {getIcon()}
        </div>
        
        <h3 className="alert-modal-title">{getTitle()}</h3>
        
        <p className="alert-modal-message">{message}</p>
        
        <button 
          className="alert-modal-button"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;

